import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useSelector } from 'react-redux';
import { CircleLoading } from 'shared';
import { Box } from '@mui/material';

export const ProtectedRoute = ({
    route = true,
    children,
    requireInvoiceReconciler = false,
    requirePurchaseReconciler = false,
}) => {
    const { user } = useAuth();
    const companyData = useSelector((state) => state.company.data);
    const companyError = useSelector((state) => state.company.error);

    if (!user?.data) {
        return <Navigate to="/login" />;
    } else if (
        !user?.data?.subscription_active &&
        user?.data?.stripe_status !== 'active' &&
        route !== 'subscriptions'
    ) {
        return <Navigate to="/subscriptions" />;
    } else if (
        route !== 'onboarding' &&
        route !== 'subscription-part-two' &&
        !user?.data?.is_onboarded &&
        (user?.data?.stripe_status == 'active' || user?.data?.stripe_status == 'trialing')
    ) {
        return <Navigate to="/onboarding" />;
    }

    if (!companyData && !companyError) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    height: '100vh',
                    alignItems: 'center',
                }}
            >
                <CircleLoading />
            </Box>
        );
    }

    if (requireInvoiceReconciler && !companyData?.is_invoice_reconciler) {
        return <Navigate to="/subscription-part-two" />;
    } else if (requirePurchaseReconciler && !companyData?.is_purchase_reconciler) {
        if (companyData?.is_invoice_reconciler) {
            return <Navigate to="/invoices/payments" />;
        }
        return <Navigate to="/purchases/for-review" />;
    }
    return children;
};
